import { boltApi } from 'store/queries/bolt-api'
import {
  GetParentProducerBySlugPayload,
  GetParentProducerBySlugResponse,
  GetPersonalizedProducersPayload,
  GetPersonalizedProducersResponse,
  GetProducerByIdOrSlugPayload,
  GetProducerByIdResponse,
  GetProducersResponse
} from './types.ts'
import { isSoldOutWithCapacity } from 'utils/producer.ts'
import { Methods } from 'types/request.ts'
import { PersonalizedProducers, Producer } from 'types/producer.ts'
import { Flow } from 'types/logging.ts'
import { createErrorTransformer } from 'store/queries/utils.ts'

export const producersBoltApi = boltApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET PRODUCERS
    getProducers: builder.query<GetProducersResponse, void>({
      query: () => ({
        url: '/producers?soldOut=false'
      }),
      transformResponse: ({ producers }) => {
        const filteredProducers = (producers as Producer[]).filter((p: Producer) => !isSoldOutWithCapacity(p))
        if (filteredProducers.length === 0) return { producers }
        return { producers: filteredProducers }
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.PRODUCERS}:getProducers]`)
    }),

    // GET PRODUCERS
    getProducerById: builder.query<GetProducerByIdResponse, GetProducerByIdOrSlugPayload>({
      query: ({ producerIdOrSlug, full }) => ({
        url: `/producers/${producerIdOrSlug}${full ? '?full=true' : ''}`
      }),
      transformErrorResponse: createErrorTransformer(`[${Flow.PRODUCERS}:getProducerById]`)
    }),

    // GET PARENT PRODUCER BY SLUG
    getParentProducerBySlug: builder.query<GetParentProducerBySlugResponse['producer'], GetParentProducerBySlugPayload>({
      query: ({ slug, full }) => ({
        url: `/producers/parents/${slug}${full ? '?full=true' : ''}`
      }),
      transformResponse: ({ producer }: GetParentProducerBySlugResponse) => {
        return producer
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.PRODUCERS}:getParentProducerBySlug]`)
    }),

    // GET PERSONALIZED PRODUCERS
    getPersonalizedProducers: builder.query<GetPersonalizedProducersResponse, GetPersonalizedProducersPayload>({
      query: ({ address }) => ({
        method: Methods.POST,
        url: '/producers/personalized',
        body: {
          address,
          expectedProducers: {
            nearest: true,
            popular: true,
            recent: true
          }
        }
      }),
      transformResponse: (data) => {
        return data as PersonalizedProducers
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.PRODUCERS}:getPersonalizedProducers]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProducersQuery, useGetProducerByIdQuery, useGetPersonalizedProducersQuery, useGetParentProducerBySlugQuery } =
  producersBoltApi
